export default __webpack_public_path__ + "static/media/Footwraps of the Precursor.94845693.jpg";